export const initNumberScales = () => {
  function initializeOptionComponent(element) {
    const optionsContainer = element.querySelector('[data-options-container]');
    const hiddenInput = element.querySelector('[data-hidden-input]');

    // Set active class based on input's value
    const activeValue = hiddenInput.value;
    if (activeValue) {
      const activeOption = Array.from(optionsContainer.children).find(child => child.textContent.trim() === activeValue);
      if (activeOption) {
        activeOption.classList.add('active');
      }
    }

    // Add click event listener to options
    optionsContainer.addEventListener('click', function (e) {
      if (e.target.classList.contains('option')) {
        // Remove active class from all options
        optionsContainer.querySelectorAll('.option').forEach(opt => opt.classList.remove('active'));

        // Add active class to clicked option
        e.target.classList.add('active');

        // Set hidden input value and dispatch input event
        hiddenInput.value = e.target.textContent.trim();
        hiddenInput.dispatchEvent(new Event('input', {
          'bubbles': true,
          'cancelable': true
        }));
      }
    });
  }

  function initializeAllOptionComponents() {
    document.querySelectorAll('[data-number-scale]').forEach(initializeOptionComponent);
  }

  document.addEventListener('DOMContentLoaded', initializeAllOptionComponents);
  Livewire.hook('message.processed', initializeAllOptionComponents);
};
